import { useEffect, useRef, useState } from "react";
import DoorPanel from "./DoorPanel";

interface StickyDoorPanelProps {
  parentRef: React.RefObject<HTMLDivElement>;
  handleAddDoor: () => void;
  doors: any[];
}

export default function StickyDoorPanel({ parentRef, doors, handleAddDoor }: StickyDoorPanelProps) {
  const [showSticky, setShowSticky] = useState(false);
  const doorPanelRef = useRef<HTMLDivElement | null>(null);

  // Efekt zarządzający paddingiem - teraz na właściwym kontenerze
  useEffect(() => {
    // <-- ZMIANA: Celujemy w .configurator-main zamiast w body
    const scrollableContainer = document.querySelector(".configurator-main");

    // Zabezpieczenie, jeśli kontener nie zostanie znaleziony
    if (!scrollableContainer) {
      console.error("StickyDoorPanel: Nie można znaleźć kontenera .configurator-main do dodania paddingu.");
      return;
    }
    
    if (showSticky) {
      scrollableContainer.classList.add("sticky-door-panel-active");
    } else {
      scrollableContainer.classList.remove("sticky-door-panel-active");
    }

    return () => {
      // Upewniamy się, że klasa jest usuwana, nawet jeśli kontener zniknie
      if (scrollableContainer) {
        scrollableContainer.classList.remove("sticky-door-panel-active");
      }
    };
  }, [showSticky]);


  // Główny efekt do logiki pokazywania/ukrywania panelu (pozostaje bez zmian)
  useEffect(() => {
    const lockButtons = document.querySelector(".LockConfiguratorButonsXD") as HTMLDivElement | null;
    const doorPanelElement = doorPanelRef.current;

    if (!doorPanelElement) {
      console.warn("StickyDoorPanel: Nie znaleziono elementu DoorPanel. Funkcjonalność wyłączona.");
      return;
    }

    let isDoorPanelVisible = true;
    let areLockButtonsVisible = false;

    const updateStickyState = () => {
      const shouldShow = !isDoorPanelVisible && !areLockButtonsVisible;
      setShowSticky(shouldShow);
    };

    const doorPanelObserver = new IntersectionObserver(
      ([entry]) => {
        isDoorPanelVisible = entry.isIntersecting;
        updateStickyState();
      },
      { root: null, threshold: 0 }
    );

    let lockButtonsObserver: IntersectionObserver | null = null;
    if (lockButtons) {
      lockButtonsObserver = new IntersectionObserver(
        ([entry]) => {
          areLockButtonsVisible = entry.isIntersecting;
          updateStickyState();
        },
        { 
        root: null, 
        threshold: 0, 
        rootMargin: "0px 0px -100px 0px" 
      }
      );
      lockButtonsObserver.observe(lockButtons);
    }

    doorPanelObserver.observe(doorPanelElement);

    return () => {
      doorPanelObserver.disconnect();
      if (lockButtonsObserver) {
        lockButtonsObserver.disconnect();
      }
    };
  }, []);

  return (
    <>
      <div ref={doorPanelRef}>
        <DoorPanel doors={doors} handleAddDoor={handleAddDoor} />
      </div>

      <div
        className="sticky-door-panel"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
          zIndex: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px 15px",
          gap: "10px",
          height: "45px",
          width: "100%",
          overflow: "hidden",
          opacity: showSticky ? 1 : 0,
          pointerEvents: showSticky ? 'auto' : 'none',
          transition: "opacity 0.3s ease-out",
        }}
      >
        <button
          onClick={handleAddDoor}
          style={{
            backgroundColor: "#005ca9",
            color: "white",
            border: "none",
            borderRadius: "25px",
            // margines pochodził wcześniej z CSS panelu admina (reguła "button" bez zakresu)
            margin: "4px",
            padding: "8px 15px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontSize: "14px",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#004080"}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#005ca9"}
        >
          Tür hinzufügen
          <img
            src={"/img/configurator/plus.svg"}
            alt="plus"
            style={{ width: "18px", height: "18px", filter: "brightness(0) invert(1)" }}
          />
        </button>
      </div>
    </>
  );
}